<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RGiErg/tc-custom/9781680574647.jpg?1705766095083" alt="This image is the cover for the book Opening Wonders, Tales of the PanCosmos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Opening Wonders, Tales of the PanCosmos
      </h1>
      <p class="bookDescription body article font2">
        <p>Countless un-parallel universes intersect in a place where science and magic function perfectly. A Crossroads World. A world that holds a fantastic and deadly secret. An ultra-advanced species, the Common, govern this world and invite other advanced species to set up enclaves where the planet's extraordinary properties draw an assortment of gods and demons like supernatural moths to a flame. The first human allowed there, Professor David Goldberg, is secretly tasked by Earth’s governments to observe the Common.But Goldberg’s mission might not be as secret as he thinks. Someone or something with unknown motivations sends truly terrifying monsters bent on taking him down. Opening Wonders. Fantasy, science fiction, mythology, adventure, mystery, rich history—and more. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rajnar Vajra
      </h2>
      
      <p class="authorDescription body article"> Rajnar Vajra was born in the year that Chuck Yeager broke the sound barrier, and something mysterious happened in Roswell, New Mexico. Coincidence? Perhaps. Aside from writing, he is a professional musician, songwriter, music teacher, a practitioner of Zen and other contemplative disciplines, and has been a jeweler, a painter, a recording engineer, and more. He follows developments in science, health, and understanding the mind&rsquo;s nature with the closest attention. Not, perish the thought, partly to mine human progress for story ideas. He has appeared more than thirty times in the pages of Analog Science Fiction and Fact and has also appeared in the online stories at Tor.com, and in Absolute Magnitude. His novel DR. ALIEN has been published by WordFire Press, which now presents OPENING WONDERS. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8de1555c